import { Link, NavLink } from 'react-router-dom';
import { Compass, Home, Plus, Bookmark, User2 } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useAuthModal } from '@/stores/auth-modal';
import { useAuth } from '@/stores/auth';

const items = [
  { to: '/', label: 'Home', icon: Home },
  { to: '/explore', label: 'Explore', icon: Compass },
  { to: '/generate', label: 'Create', icon: Plus, primary: true },
  { to: '/saved', label: 'Saved', icon: Bookmark },
  { to: '/account', label: 'Profile', icon: User2 },
];

export const MobileBottomNav = () => {
  const openAuth = useAuthModal((s) => s.openAuth);
  const { isAuthenticated } = useAuth();
  return (
    <nav
      aria-label="Primary"
      className="md:hidden fixed bottom-0 left-0 right-0 z-30 border-t border-border-subtle bg-background/90 backdrop-blur"
    >
      <ul className="grid grid-cols-5 px-2 pt-1.5 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
        {items.map(({ to, label, icon: Icon, primary }) => {
          if (primary) {
            if (isAuthenticated) {
              return (
                <li key={to} className="flex justify-center">
                  <Link
                    to={to}
                    className="-mt-5 grid h-12 w-12 place-items-center rounded-full bg-accent text-accent-foreground shadow-lg shadow-black/40 active:scale-95 transition-transform"
                    aria-label={label}
                  >
                    <Icon className="h-5 w-5" />
                  </Link>
                </li>
              );
            }
            return (
              <li key={to} className="flex justify-center">
                <button
                  type="button"
                  onClick={() => openAuth('signup', 'Sign up to generate images with library prompts.')}
                  className="-mt-5 grid h-12 w-12 place-items-center rounded-full bg-accent text-accent-foreground shadow-lg shadow-black/40 active:scale-95 transition-transform"
                  aria-label={label}
                >
                  <Icon className="h-5 w-5" />
                </button>
              </li>
            );
          }
          return (
            <li key={to} className="flex justify-center">
              <NavLink
                to={to}
                end={to === '/'}
                className={({ isActive }) =>
                  cn(
                    'flex flex-col items-center gap-0.5 py-1 text-[10px] text-text-muted hover:text-foreground transition-colors',
                    isActive && 'text-foreground',
                  )
                }
              >
                <Icon className="h-5 w-5" />
                {label}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export const MobileBottomSpacer = () => <div aria-hidden className="md:hidden h-16" />;